import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const updateMailingListName = (
    mailingListId: string,
    mailingListName: string,
    successMessage: string,
    errorMessage: string,
    mutate: () => void,
    selectedSchema: string,
) => {
    const url = `${process.env.REACT_APP_API_URL}/mailing_list/${mailingListId}`;

    const requestOptions = {
        method: 'POST',
        headers: generateHeaders(selectedSchema),
        body: JSON.stringify({ mailing_list_id: mailingListId, name: mailingListName }),
    };

    fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');
            } else {
                displayToast(successMessage, 'success');
                mutate();
            }
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default updateMailingListName;
